import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'textTruncate',
    standalone: false
})
export class TextTruncatePipe implements PipeTransform {

  transform(value: string, lengthSize: number): string {
    const size = lengthSize ?? 50

    return (value.length > size) ? value.slice(0, size).concat("...") : value;
  }
}
